import { render, staticRenderFns } from "./MembershipBlock.vue?vue&type=template&id=03c0cefa"
import script from "./MembershipBlock.vue?vue&type=script&lang=js"
export * from "./MembershipBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports